import React from 'react';
import { connect } from 'react-redux';
import { Sidebar } from 'react-pro-sidebar';
import TextField from '@mui/material/TextField';
import PerfectScrollbar from 'perfect-scrollbar';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

// core components
import routes from '../routes.js';
import constants from '../constants.js';
import Searchbox from '../components/searchbox.js';
import Colorsdynamic from '../components/Colorsdynamic.js';
import SidebarMenu from '../components/Sidebar/Sidebar.jsx';
import WorkspaceHeader from '../components/workspaceHeader.js';
import AdminNavbar from '../components/Navbars/AdminNavbar.jsx';
import ViewStateManager from '../utils/viewStateManager.js';
import { getWorkspacePath } from '../utils/workspaceUtils.js';

import { setNewDealModal } from '../store/Deals/index.js';
import { setNewAgentModal } from '../store/Agent/index.js';
import { setAssistant } from '../store/Assistant/index.js';
import { setCtrlPressed } from '../store/Settings/index.js';


let ps;
class Admin extends React.Component {
  constructor(props) {
    super(props);

    // Load saved sidebar state
    const savedSidebarState = ViewStateManager.getSidebarState();

    this.state = {
      search: "",
      openRoutes: false,
      routesState: routes,
      showDropdown: false,
      dropdownOpen: false,
      shouldScrollTop: false,
      backgroundColor: 'blue',
      selectedStatusDetails: "",
      collapsed: savedSidebarState.isOpen !== undefined ? !savedSidebarState.isOpen : true,
    };
    this.inputRef = React.createRef();
    this.searchBoxRef = React.createRef();
    this.setState({ shouldScrollTop: true });
    this.dropdownInputRef = React.createRef();
    this.closeTimeout = null;
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('keyup', this.handleKeyUp);
    document.addEventListener('mousedown', this.handleClickOutside);
    if (navigator.platform.indexOf('Win') > -1) {
      document.documentElement.className += ' perfect-scrollbar-on';
      document.documentElement.classList.remove('perfect-scrollbar-off');
      ps = new PerfectScrollbar(this.refs.mainPanel, { suppressScrollX: true });
      let tables = document.querySelectorAll('.table-responsive');
      for (let i = 0; i < tables.length; i++) ps = new PerfectScrollbar(tables[i]);
    }

    let role = localStorage.getItem('role');
    let routesState = this.state['routesState'];

    if (role == 'agent') {
      let remove = ['Campaign', 'Accounts', 'Users'];
      routesState = routesState.filter(({ name }) => !remove.includes(name));
    }

    // Filter admin routes - only show for admin users
    if (role !== 'admin') routesState = routesState.filter(route => !route.adminOnly);
    this.setState({ routesState });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keyup', this.handleKeyUp);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
    if (this._sidebarResizeTimeout) {
      clearTimeout(this._sidebarResizeTimeout);
    }
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
      document.documentElement.className += ' perfect-scrollbar-off';
      document.documentElement.classList.remove('perfect-scrollbar-on');
    }
  }

  componentDidUpdate(e) {
    if (e.history.action === 'PUSH') {
      if (navigator.platform.indexOf('Win') > -1) {
        let tables = document.querySelectorAll('.table-responsive');
        for (let i = 0; i < tables.length; i++) ps = new PerfectScrollbar(tables[i]);
      }
      if (this.state.shouldScrollTop && !prevState.shouldScrollTop) {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        if (this.refs.mainPanel) this.refs.mainPanel.scrollTop = 0;
        this.setState({ shouldScrollTop: false });
      }
    }
  }

  handleKeyDown = (e) => {
    // Update Ctrl key state

    if (e['ctrlKey'] && !this.props.isCtrlPressed)
      this.props.setCtrlPressed(true);

    // Handle Ctrl+number shortcuts for navigation
    if (e['ctrlKey'] && e['key'] >= '1' && e['key'] <= '9') {
      e.preventDefault();

      let route = routes.find(route => route['shortcut'] === e['key']);
      if (route && this.props['history']) {
        const workspacePath = getWorkspacePath(route['path'], this.props.currentWorkspace?._id);
        this.props['history'].push(workspacePath);
      }
    }

    if (e['key'] === '/' && !this.props['isAssistant']) {
      // Don't trigger if user is typing in an input, textarea, or contenteditable element
      const activeElement = document.activeElement;
      const isTyping = activeElement && ( activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable);
      if (!isTyping) {
        e.preventDefault();
        this.setState({ showDropdown: true }, () => setTimeout(() => this.dropdownInputRef.current?.focus(), 0));
      }
    }

    if (e['key'] === 'Escape') {
      this.setState({ showDropdown: false });
      if (this.dropdownInputRef) this.dropdownInputRef.current?.focus();

      // Close Assistant
      this.props.setAssistant(false);

      // Close Create Deal Modal
      this.props.setNewDealModal(false);

      // Close Create Agent Modal
      this.props.setNewAgentModal(false);
    }
  }

  handleKeyUp = (e) => {
    // Reset Ctrl key state when released
    if (!e['ctrlKey'] && this.props.isCtrlPressed) this.props.setCtrlPressed(false);
  }

  showDropdown = () => this.setState({ showDropdown: true });
  toggleDropDownPlus = () => this.setState(prevState => ({ dropdownOpen: !prevState['dropdownOpen'] }));
  handleBottomSearchClick = () => this.setState({ showDropdown: true }, () => requestAnimationFrame(() => this.dropdownInputRef.current?.focus()));
  handleClickOutside = (e) => {
    // Check if the search dropdown is actually open before trying to close it
    if (!this.state.showDropdown) return;

    // Check if click is within the search box or dropdown
    if (this.searchBoxRef.current && !this.searchBoxRef.current.contains(e.target)) {
      // Clear any existing timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }

      // Additional check to prevent closing during loading
      const isLoading = this.props.isLoadButton;
      if (!isLoading) {
        // Add a small delay to prevent premature closing during re-renders
        this.closeTimeout = setTimeout(() => {
          this.setState({ showDropdown: false });
        }, 100);
      }
    }
  }

  render() {
    const { activeTab, showDropdown, dropdownOpen } = this['state'];
    return (
      <div className='wrapper'>
        <div className='wrapper-inner'>
          <Sidebar collapsed={this['state']['collapsed']}>
            <SidebarMenu
              {...this['props']}
              activeTab={activeTab}
              routes={this.state.routesState}
              bgColor={this['state']['backgroundColor']}
              style={{ width: this.state.collapsed ? '80px' : '250px' }}
              logo={{ outterLink: 'https://sellagent.ai', text: 'sellagent.ai' }}
              isCtrlPressed={this.props.isCtrlPressed}
            />
            <button className='sb-button' onClick={() => {
              const newCollapsedState = !this.state.collapsed;
              if (this._sidebarResizeTimeout) {
                clearTimeout(this._sidebarResizeTimeout);
              }
              this.setState({ collapsed: newCollapsedState }, () => {
                this._sidebarResizeTimeout = setTimeout(() => {
                  window.dispatchEvent(new Event('resize'));
                }, 350);
              });
              ViewStateManager.setSidebarState({ isOpen: !newCollapsedState });
            }}>
              <span className='icon'><svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.5' y='0.5' width='27' height='27' rx='7.5' fill='white' /><rect x='0.5' y='0.5' width='27' height='27' rx='7.5' stroke='#F6F6F6' /><path d='M16.4715 10.4713C16.7318 10.211 16.7318 9.78886 16.4715 9.52851C16.2111 9.26816 15.789 9.26816 15.5287 9.52851L11.5287 13.5285C11.2683 13.7889 11.2683 14.211 11.5287 14.4713L15.5287 18.4713C15.789 18.7317 16.2111 18.7317 16.4715 18.4713C16.7318 18.211 16.7318 17.7889 16.4715 17.5285L12.9429 13.9999L16.4715 10.4713Z' fill='black' /></svg></span>
            </button>
          </Sidebar>
          <div className='main-panel' ref='mainPanel' data={this['state']['backgroundColor']}>
            <AdminNavbar {...this['props']} brandText='Dashboard' />
            <div className='content'>
              <div className='page-header-new'>
                <div className='seachbox-inner'>
                  <div className="searchbox" ref={this.searchBoxRef}>
                    <i class="icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.40156 10.6464C2.74292 10.6464 0.578369 8.48183 0.578369 5.82319C0.578369 3.16455 2.74292 1 5.40156 1C8.0602 1 10.2248 3.16455 10.2248 5.82319C10.2248 8.48183 8.0602 10.6464 5.40156 10.6464ZM5.40156 1.70583C3.12878 1.70583 1.2842 3.55511 1.2842 5.82319C1.2842 8.09127 3.12878 9.94055 5.40156 9.94055C7.67434 9.94055 9.51892 8.09127 9.51892 5.82319C9.51892 3.55511 7.67434 1.70583 5.40156 1.70583Z" fill="#50525870" stroke="#50525870" stroke-width="0.236842" /><path d="M12.8959 13.7066C12.8021 13.7068 12.7083 13.6723 12.6342 13.5984L8.68189 9.63155C8.5386 9.48864 8.53829 9.2518 8.68119 9.10852C8.82409 8.96524 9.06094 8.96492 9.20422 9.10783L13.1565 13.0747C13.2998 13.2176 13.3001 13.4545 13.1572 13.5977C13.0833 13.6718 12.9896 13.7065 12.8959 13.7066Z" fill="#50525870" stroke="#50525870" stroke-width="0.236842" /></svg></i>
                    <TextField
                      fullWidth
                      hiddenLabel
                      size="small"
                      name='search'
                      variant="standard"
                      inputRef={this.inputRef}
                      placeholder='Search agents, deals, contacts, companies...'
                      onClick={this.handleBottomSearchClick}
                    />
                    <button className='right-slash' onClick={this.showDropdown} ref={this.dropdownInputRef}>/</button>
                    {showDropdown && <div className='search-dropdown'> <div className='search-dropdown-item'> <div className='tab-box'> <Searchbox ref={this.dropdownInputRef} currentWorkspace={this.props.currentWorkspace} /></div> </div></div>}
                  </div>
                  <div className={`custom-dropdown-wrapper ${dropdownOpen ? 'compnoone' : ''}`} >
                    <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropDownPlus}>
                      <DropdownToggle caret>
                        <button className='add-button'><i class="icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.93752 15.8775C7.25217 15.8775 6.68384 15.3092 6.68384 14.6238V1.25118C6.68384 0.565836 7.25217 -0.00250053 7.93752 -0.00250053C8.62287 -0.00250053 9.19121 0.565836 9.19121 1.25118V14.6238C9.19121 15.3092 8.62287 15.8775 7.93752 15.8775Z" fill="var(--primary-color)" /><path d="M14.6239 9.19118H1.25124C0.565895 9.19118 -0.00244141 8.62285 -0.00244141 7.9375C-0.00244141 7.25215 0.565895 6.68382 1.25124 6.68382H14.6239C15.3092 6.68382 15.8776 7.25215 15.8776 7.9375C15.8776 8.62285 15.3092 9.19118 14.6239 9.19118Z" fill="var(--primary-color)" /></svg></i></button>
                      </DropdownToggle>
                      <DropdownMenu style={{ top: '10px' }}>
                        <DropdownItem onClick={() => this.props.setNewAgentModal(true)}>Create Agent</DropdownItem>
                        <DropdownItem onClick={() => this.props.setNewDealModal(true)}>Create Deal</DropdownItem>
                        <DropdownItem onClick={() => this.props['history'].push(getWorkspacePath('/objects/contacts', this.props.currentWorkspace?._id))}>Create Contact</DropdownItem>
                        <DropdownItem onClick={() => this.props['history'].push(getWorkspacePath('/objects/companies', this.props.currentWorkspace?._id))}>Create Company</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  {/* <button className='btn-style-new'>+ Create</button> */}
                </div>
                <WorkspaceHeader />
              </div>
              {this['props']['children']}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = { setNewDealModal, setNewAgentModal, setAssistant, setCtrlPressed };
const mapStateToProps = ({ Assistant: { isAssistant }, Auth: { isLoadButton }, Settings: { isCtrlPressed, userDetails, currentWorkspace } }) => ({ isLoadButton, isAssistant, isCtrlPressed, userDetails, currentWorkspace });

export default connect(mapStateToProps, mapDispatchToProps)(Admin);